// extracted by mini-css-extract-plugin
export default {"home_page":"HomePage_home_page__9ksXU"};